module.exports = __webpack_public_path__ + "img/mt18.791aa0e4.jpg";